import { NgClass } from "@angular/common";
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { isNullish } from "@commonHelpers/math-utils";
import { NgbCollapse } from "@commonNodeModules/@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@commonNodeModules/@ngx-translate/core";
import { timer } from "rxjs";


@Component({
	selector: "app-catalog-list-navigation",
	templateUrl: "./catalog-list-navigation.component.html",
	styleUrls: ["./catalog-list-navigation.component.scss"],
	imports: [NgClass, NgbCollapse, TranslatePipe]
})
export class CatalogListNavigationComponent implements OnInit, OnChanges {
	@Input() selectedGroupItemId: number;
	@Input() selectedItemId: number;
	@Input() groups: CatalogListNavigationGroupDto[];
	@Output() groupChanged = new EventEmitter<CatalogListNavigationGroupDto>();
	@Output() changed = new EventEmitter<({ groupId: number, item: CatalogListNavigationDto })>();
	@Output() groupOffsetChanged = new EventEmitter<number>();

	public groupItemsCollapsed = new Array<boolean>();

	constructor(
		private elRef: ElementRef,
	) { }

	ngOnInit() {
		if (this.groups) {
			this.collapseAll();
			this.groupItemsCollapsed[this.selectedGroupItemId] = false;

		}
	}

	ngOnChanges() {
		this.collapseAll();
		this.groupItemsCollapsed[this.selectedGroupItemId] = false;
	}

	private collapseAll() {
		this.groups?.forEach(e => {
			this.groupItemsCollapsed[e.id] = true;
		});
	}

	public isCollapsed(groupItemId: number) {
		if (this.groupItemsCollapsed) {
			return this.groupItemsCollapsed[groupItemId];
		} else {
			return true;
		}
	}

	public elementNavigationId(prefix: string, id: number) {
		if (isNullish(id)) {
			return `${prefix}new`
		}
		return `${prefix}${id}`
	}

	public groupItemClicked(item: CatalogListNavigationDto) {

		this.selectedGroupItemId = item.id;
		this.collapseAll();
		// toggle selected collapse panel
		this.groupItemsCollapsed[item.id] = !this.groupItemsCollapsed[item.id];

		this.groupChanged.emit(item);
		this.scrollToCurrent(item.id);
	}

	private scrollToCurrent(itemGroupId) {
		const currentElement = this.elRef.nativeElement.querySelector(`#${this.elementNavigationId('custom-panel-', itemGroupId)}`);
		const offsetScrollSubscription = timer(100).subscribe(() => {
			this.groupOffsetChanged.emit(currentElement?.offsetTop - 7)
			offsetScrollSubscription.unsubscribe();
		})
	}

	public itemClicked(groupItem: CatalogListNavigationGroupDto, item: CatalogListNavigationDto) {
		if (
			!isNullish(groupItem?.id) &&
			!isNullish(item?.id)
		) {
			this.selectedItemId = item.id;
			this.changed.emit({ groupId: this.selectedGroupItemId, item });
		}
	}
}

export interface CatalogListNavigationGroupDto {
	id: number;
	titleResourceKey?: string | undefined;
	logo?: string | undefined;
	items?: CatalogListNavigationDto[]
}

export interface CatalogListNavigationDto {
	id: number;
	titleResourceKey?: string | undefined;
	items?: any[];
}
